import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";

import Header from "./components/Header";
import SideNav from "./components/SideNav";
import Footer from "./components/Footer";
import Login from "./Seguridad/Login";
import Menus from "./Seguridad/Menus";
import Perfil from "./Seguridad/Perfiles";
import Acceso from "./Seguridad/Accesos";
import PerfilAcceso from "./Seguridad/PerfilAccesos";

import { UserProvider, useUser } from "./contexts/UserContext";
import { AccesosProvider } from "./contexts/AccesosContext";
import { SucursalProvider } from "./contexts/SucursalContext";

import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { setupApiInterceptor, isTokenValid, clearToken } from "./utils/apiInterceptor";

// --- IMPORTS DE TUS PANTALLAS (déjalos igual como los tienes) ---
import GestionPaises from "./General/GestionPaises";
import GestionDepartamentos from "./General/GestionDepartamentos";
import GestionMunicipios from "./General/GestionMunicipios";
import GestionBarrios from "./General/GestionBarrios";
import GestionAreas from "./General/GestionAreas";
import GestionEtnias from "./General/GestionEtnias";
import GestionRazas from "./General/GestionRazas";
import GestionSucursales from "./Seguridad/GestionSucursales";
import GestionProfesiones from "./General/GestionProfesiones";
import GestionProcesos from "./General/GestionProcesos";
import GestionMetodos from "./General/GestionMetodos";
import GestionEquipos from "./General/GestionEquipos";
import GestionUnidades from "./General/GestionUnidadMedidas";
import GestionModulos from "./General/GestionModulos";
import UsuarioSucursalPerfil from "./Seguridad/UsuariosSucursalPerfil";
import Clientes from "./Clientes/Clientes";
import TiposAnalisis from "./Analisis/TiposAnalisis";
import Origenes from "./Analisis/Origenes";
import Descuentos from "./Analisis/Descuentos";
import GestionAnalisisPerfil from "./Analisis/GestionAnalisisPerfil";
import Usuarios from "./Seguridad/Usuarios";
import GestionCotizacion from "./Cotizaciones/GestionCotizacion";
import Cotizaciones from "./Cotizaciones/Cotizaciones";
import GestionOrdenTrabajo from "./Cotizaciones/GestionOrdenTrabajo";
import OrdenesTrabajo from "./Cotizaciones/OrdenesTrabajo";
import AdministracionResultados from "./Cotizaciones/AdministracionResultados";
import GestionPromocionesDescuento from "./Promociones/GestionPromocionesDescuento";
import GestionPromocionesDAnalisis from "./Promociones/GestionPromocionesDAnalisis";
import ListaPromociones from "./Promociones/ListaPromociones";
import GestionPromocionesTarjeta from "./Promociones/GestionPromocionesTarjeta";
import TomaMuestra from "./Analisis/TomaMuestra";
import TomaMuestraPorCodigo from "./Analisis/TomaMuestraPorCodigo";
import GestionEmpresas from "./Seguridad/GestionEmpresas";
import GestionMedicos from "./PaginaWeb/GestionMedicos";
import TrasladoPuntos from "./Cotizaciones/TrasladoPuntos";
import GestionTipoTransacciones from "./Arqueos/GestionTipoTransacciones";
import MovimientosExtraordinarios from "./Arqueos/MovimientosExtraordinarios";
import MovimientosCajero from "./Arqueos/MovimientosCajero";
import GestionCajas from "./Arqueos/GestionCajas";
import CierreCaja from "./Arqueos/CierreCaja";
import GestionPermisos from "./Seguridad/Permisos";
import AnalisisClientes from "./Cotizaciones/AnalisisClientes";
import GestionEstadosTomaMuestra from "./Analisis/GestionEstadosTomaMuestra";
import GestionEtapaOportunidad from "./CRM/GestionEtapaOportunidad";
import GestionPrioridadTarea from "./CRM/GestionPrioridadTarea";
import GestionEstadoTarea from "./CRM/GestionEstadoTarea";
import GestionOportunidad from "./CRM/GestionOportunidad";
import GestionCampaña from "./CRM/GestionCampaña";
import GestionTipoObjetivo from "./CRM/GestionTipoObjetivo";
import GestionTipoGasto from "./CRM/GestionTipoGasto";
import GestionEncuesta from "./CRM/GestionEncuesta";
import GestionAreaEncuesta from "./CRM/GestionAreaEncuesta";
import GestionEncuestaDashboard from "./CRM/GestionEncuestasDashboard";
import GestionCategoriaPregunta from "./CRM/GestionCategoriaPregunta";
import DashboardTomaMuestra from "./DashboardGeneral/DashboardProductividadCargaOperativa";
import KanbanTomaMuestra from "./Analisis/KanbanTomaMuestra";
import HistoricoTomaMuestras from "./Analisis/HistoricoTomaMuestras";
import GestionOrdenTrabajoHospital from "./Cotizaciones/GestionOrdenTrabajoHospital";
import OrdenesTrabajoHospital from "./Cotizaciones/OrdenesTrabajoHospital";
import GestionTipoAtencion from "./Cotizaciones/GestionTipoAtencion";
import GestionCuentaContable from "./EconomicaContable/GestionCuentaContable";
import GestionTipoPartidaContable from "./EconomicaContable/GestionTipoPartidaContable";
import GestionTipoPartida from "./EconomicaContable/GestionTipoPartida";
import GestionCentroCosto from "./EconomicaContable/GestionCentroCosto";
import GestionUnidadNegocioSucursal from "./EconomicaContable/GestionUnidadNegocioSucursal";
import GestionPartidaContable from "./EconomicaContable/GestionPartidaContable";
import InformesFinancieros from "./EconomicaContable/InformesFinancieros";
import GestionPrestamosBancarios from "./EconomicaContable/GestionPrestamosBancarios";
import GestionAuxiliares from "./EconomicaContable/GestionAuxiliares";
import ConfiguracionAuxiliares from "./EconomicaContable/ConfiguracionAuxiliares";
import GestionTiposDocumento from "./EconomicaContable/GestionTiposDocumento";
import ConciliacionBancaria from "./EconomicaContable/ConciliacionBancaria";
import GestionBancos from "./EconomicaContable/GestionBancos";
import GestionCuentasBancarias from "./EconomicaContable/GestionCuentasBancarias";
import ControlCierresDiarios from "./EconomicaContable/ControlCierresDiarios";
import ReporteFacturas from "./EconomicaContable/ReporteFacturas";
import ReporteCxCSaldos from "./EconomicaContable/ReporteCxCSaldos";
import ChatWhatsapp from "./components/Chat/ChatContainer";
import DashboardPausa from "./Tickets/DashboardPausa";
import DashboardProductividadCargaOperativa from "./DashboardGeneral/DashboardProductividadCargaOperativa";

// --- MÓDULO IMAGENOLOGÍA / DICOM ---
import ConfigCatalogos from "./Imagenes/ConfigCatalogos";
import ConfigProyecciones from "./Imagenes/ConfigProyecciones";
import DicomWorklist from "./Imagenes/DicomWorklist";
import AdminProductoImagen from "./Imagenes/AdminProductoImagen";
const DicomViewer = lazy(() => import("./Imagenes/DicomViewer"));
import DicomUpload from "./Imagenes/DicomUpload";
import EncuestaForm from "./Imagenes/EncuestaForm";
import InformeForm from "./Imagenes/InformeForm";
import CapturasPantalla from "./Imagenes/CapturasPantalla";
// ---------------------------------------------------------------

function App() {
  // ✅ CAMBIO: autenticación solo por token válido (no por localStorage.isAuthenticated)
  const [isAuthenticated, setIsAuthenticated] = useState(() => isTokenValid());
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    setupApiInterceptor();

    const onLogout = () => {
      clearToken();
      // opcional: limpiar username si lo guardas
      // localStorage.removeItem("username");
      setIsAuthenticated(false);
    };

    window.addEventListener("auth:logout", onLogout);

    // ✅ CAMBIO: validar al arrancar (F5)
    setIsAuthenticated(isTokenValid());
    setAuthLoading(false);

    // ✅ CAMBIO: Verificación periódica de token (cada 60 segundos)
    const tokenCheckInterval = setInterval(() => {
      if (!isTokenValid()) {
        console.warn('Token expirado detectado en verificación periódica');
        clearToken();
        setIsAuthenticated(false);
      }
    }, 60000); // 60 segundos

    return () => {
      window.removeEventListener("auth:logout", onLogout);
      clearInterval(tokenCheckInterval);
    };
  }, []);

  const updateAuthentication = (status) => {
    setIsAuthenticated(status);
    if (!status) clearToken();
  };

  if (authLoading) return null;

  return (
    <UserProvider>
      <SucursalProvider>
        <BodyClassManager>
          <AccesosProvider>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login setIsAuthenticated={updateAuthentication} />} />

                <Route
                  path="/"
                  element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />}
                >
                  <Route index element={<OrdenesTrabajo />} />
                  <Route path="menu" element={<Menus />} />
                  <Route path="Sucursales" element={<GestionSucursales />} />
                  <Route path="Perfiles" element={<Perfil />} />
                  <Route path="Accesos" element={<Acceso />} />
                  <Route path="PerfilAccesos" element={<PerfilAcceso />} />
                  <Route path="GestionPaises" element={<GestionPaises />} />
                  <Route path="GestionDepartamentos" element={<GestionDepartamentos />} />
                  <Route path="GestionMunicipios" element={<GestionMunicipios />} />
                  <Route path="GestionBarrios" element={<GestionBarrios />} />
                  <Route path="GestionAreas" element={<GestionAreas />} />
                  <Route path="GestionEtnias" element={<GestionEtnias />} />
                  <Route path="GestionRazas" element={<GestionRazas />} />
                  <Route path="GestionProfesiones" element={<GestionProfesiones />} />
                  <Route path="GestionProcesos" element={<GestionProcesos />} />
                  <Route path="GestionMetodos" element={<GestionMetodos />} />
                  <Route path="GestionEquipos" element={<GestionEquipos />} />
                  <Route path="GestionUnidadesMedidas" element={<GestionUnidades />} />
                  <Route path="GestionModulos" element={<GestionModulos />} />
                  <Route path="UsuarioSucursalPerfil" element={<UsuarioSucursalPerfil />} />
                  <Route path="GestionClientes" element={<Clientes />} />
                  <Route path="GestionTipoAnalisis" element={<TiposAnalisis />} />
                  <Route path="GestionOrigenes" element={<Origenes />} />
                  <Route path="GestionDescuentos" element={<Descuentos />} />
                  <Route path="GestionAnalisisPerfil" element={<GestionAnalisisPerfil />} />
                  <Route path="GestionUsuarios" element={<Usuarios />} />
                  <Route path="GestionCotizacion" element={<GestionCotizacion />} />
                  <Route path="Cotizaciones" element={<Cotizaciones />} />
                  <Route path="GestionOrdenTrabajo" element={<GestionOrdenTrabajo />} />
                  <Route path="OrdenesTrabajo" element={<OrdenesTrabajo />} />
                  <Route path="AdministracionResultados" element={<AdministracionResultados />} />
                  <Route path="GestionPromocionesDescuento" element={<GestionPromocionesDescuento />} />
                  <Route path="GestionPromocionesDAnalisis" element={<GestionPromocionesDAnalisis />} />
                  <Route path="ListaPromociones" element={<ListaPromociones />} />
                  <Route path="GestionPromocionesTarjeta" element={<GestionPromocionesTarjeta />} />
                  <Route path="TomaMuestra" element={<TomaMuestra />} />
                  <Route path="TomaMuestraPorCodigo" element={<TomaMuestraPorCodigo />} />
                  <Route path="GestionEmpresas" element={<GestionEmpresas />} />
                  <Route path="GestionMedicos" element={<GestionMedicos />} />
                  <Route path="TrasladoPuntos" element={<TrasladoPuntos />} />
                  <Route path="GestionTipoTransacciones" element={<GestionTipoTransacciones />} />
                  <Route path="GestionCajas" element={<GestionCajas />} />
                  <Route path="MovimientosExtraordinarios" element={<MovimientosExtraordinarios />} />
                  <Route path="MovimientosCajero" element={<MovimientosCajero />} />
                  <Route path="CierreCaja" element={<CierreCaja />} />
                  <Route path="GestionPermisos" element={<GestionPermisos />} />
                  <Route path="AnalisisClientes" element={<AnalisisClientes />} />
                  <Route path="GestionEstadosTomaMuestra" element={<GestionEstadosTomaMuestra />} />
                  <Route path="GestionOrdenTrabajoHospital" element={<GestionOrdenTrabajoHospital />} />
                  <Route path="OrdenesTrabajoHospital" element={<OrdenesTrabajoHospital />} />
                  <Route path="GestionTipoAtencion" element={<GestionTipoAtencion />} />
                  <Route path="GestionEtapaOportunidad" element={<GestionEtapaOportunidad />} />
                  <Route path="GestionPrioridadTarea" element={<GestionPrioridadTarea />} />
                  <Route path="GestionEstadoTarea" element={<GestionEstadoTarea />} />
                  <Route path="GestionOportunidad" element={<GestionOportunidad />} />
                  <Route path="GestionCampaña" element={<GestionCampaña />} />
                  <Route path="GestionTipoObjetivo" element={<GestionTipoObjetivo />} />
                  <Route path="GestionTipoGasto" element={<GestionTipoGasto />} />
                  <Route path="GestionEncuesta" element={<GestionEncuesta />} />
                  <Route path="GestionAreaEncuesta" element={<GestionAreaEncuesta />} />
                  <Route path="GestionEncuestaDashboard" element={<GestionEncuestaDashboard />} />
                  <Route path="GestionCategoriaPregunta" element={<GestionCategoriaPregunta />}/>
                  <Route path="DashboardTomaMuestra" element={<DashboardTomaMuestra />} />
                  <Route path="KanbanTomaMuestra" element={<KanbanTomaMuestra />} />
                  <Route path="HistoricoTomaMuestras" element={<HistoricoTomaMuestras />} />
                  <Route path="GestionCuentaContable" element={<GestionCuentaContable />} />
                  <Route path="GestionTipoPartidaContable" element={<GestionTipoPartidaContable />} />
                  <Route path="GestionTipoPartida" element={<GestionTipoPartida />} />
                  <Route path="GestionCentroCosto" element={<GestionCentroCosto />} />
                  <Route path="GestionUnidadNegocioSucursal" element={<GestionUnidadNegocioSucursal />} />
                  <Route path="GestionPartidaContable" element={<GestionPartidaContable />} />
                  <Route path="InformesFinancieros" element={<InformesFinancieros />} />
                  <Route path="GestionPrestamosBancarios" element={<GestionPrestamosBancarios />} />
                  <Route path="GestionAuxiliares" element={<GestionAuxiliares />} />
                  <Route path="ConfiguracionAuxiliares" element={<ConfiguracionAuxiliares />} />
                  <Route path="GestionTiposDocumento" element={<GestionTiposDocumento />} />
                  <Route path="ConciliacionBancaria" element={<ConciliacionBancaria />} />
                  <Route path="GestionBancos" element={<GestionBancos />} />
                  <Route path="GestionCuentasBancarias" element={<GestionCuentasBancarias />} />
                  <Route path="ControlCierresDiarios" element={<ControlCierresDiarios />} />
                  <Route path="ReporteFacturas" element={<ReporteFacturas />} />
                  <Route path="ReporteCxCSaldos" element={<ReporteCxCSaldos />} />
                  <Route path="Chat" element={<ChatWhatsapp />} />
                  <Route path="DashboardPausa" element={<DashboardPausa />} />
                  <Route path="DashboardProductividadCargaOperativa" element={<DashboardProductividadCargaOperativa />} />
                  {/* --- MÓDULO IMAGENOLOGÍA / DICOM --- */}
                  <Route path="ImgLados" element={<ConfigCatalogos modo="lados" />} />
                  <Route path="ImgTiposEntrega" element={<ConfigCatalogos modo="tiposentrega" />} />
                  <Route path="ImgProyecciones" element={<ConfigProyecciones />} />
                  <Route path="ImgWorklist" element={<DicomWorklist />} />
                  <Route path="ImgAdminProductoImagen" element={<AdminProductoImagen />} />
                  <Route path="ImgUpload" element={<DicomUpload />} />
                  <Route path="ImgVisor" element={<Suspense fallback={<div>Cargando visor...</div>}><DicomViewer /></Suspense>} />
                  <Route path="ImgEncuesta" element={<EncuestaForm />} />
                  <Route path="ImgInformes" element={<InformeForm />} />
                  <Route path="ImgCapturas" element={<CapturasPantalla />} />
                </Route>

                <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} replace />} />
              </Routes>
            </div>
          </AccesosProvider>
        </BodyClassManager>
      </SucursalProvider>
    </UserProvider>
  );
}


function Layout() {
  const { user, userLoading } = useUser();

  // ✅ CAMBIO: Verificar token válido antes de esperar a que termine userLoading
  // Esto previene que se renderice brevemente OrdenesTrabajo con token expirado
  if (!isTokenValid()) {
    clearToken();
    return <Navigate to="/login" replace />;
  }

  if (userLoading) return <div style={{ padding: 20 }}>Cargando sesión...</div>;

  // ✅ Si ya terminó de cargar y sigue null, entonces NO hay sesión usable
  if (!user) return <Navigate to="/login" replace />;

  return (
    <>
      <Header />
      <SideNav />
      <div className="content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
function BodyClassManager({ children }) {
  const location = useLocation();

  useEffect(() => {
    document.body.className = location.pathname === "/login" ? "login" : "nav-md";
  }, [location]);

  return children;
}

export default App;